import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CButton, CModal, CModalBody } from '@coreui/react-pro';

import { addTimezoneLocal } from '../../../../utils';
import { LOCAL_CART, LOCAL_COUPON, LOCAL_COUPON_VOUCHERS, LOCAL_ORG_USER, ORG_USER_ROLES, POPUP_TYPE } from '../../../../constants';

import PageBack from '../../../General/Link/PageBack';

import { setCurrentCountry } from '../../Subscriber/GlobalStates/CurrentCountry/actions';
import { setShow } from '../../../../actions/general';
import { actionClearCartCouponVouchers } from '../Cart/actions';

const SelectOrCreateOrganization = ({ handleSelectOrganization }) => {
     const dispatch = useDispatch();
     const managedOrganizations = useSelector((state) => state.subscriber.managedOrganizations);

     const orgUser = JSON.parse(localStorage.getItem(LOCAL_ORG_USER));

     let listOrgs = [];

     if (managedOrganizations) {
          listOrgs = managedOrganizations.filter((managedOrg) => managedOrg.role === ORG_USER_ROLES.OWNER);

          if (orgUser) {
               listOrgs = listOrgs.filter((listOrg) => listOrg.organizationId !== orgUser.organizationId);
          }
     }

     const handleShowSelectOrgs = () => {
          dispatch(setShow(POPUP_TYPE.SELECT_ORG));
     };

     const handleCreateOrgButtonClick = () => {
          dispatch(setShow(POPUP_TYPE.CREATE_ORG));
     };

     const handleBackClick = () => {
          dispatch(setShow(POPUP_TYPE.SWITCH_PURCHASE));
     };

     const handleSelectOrg = (organizationId) => {
          const managedOrganizationSelected = listOrgs.find((listOrg) => listOrg.organization.id === organizationId);
          const isSetCartLocal = false;

          handleSelectOrganization(organizationId, isSetCartLocal);
          addTimezoneLocal(managedOrganizationSelected?.organization?.timezone);

          localStorage.removeItem(LOCAL_CART);
          localStorage.removeItem(LOCAL_COUPON);
          localStorage.removeItem(LOCAL_COUPON_VOUCHERS);
          dispatch(actionClearCartCouponVouchers());

          if (managedOrganizationSelected) {
               localStorage.setItem(LOCAL_ORG_USER, JSON.stringify(managedOrganizationSelected));
          }

          if (managedOrganizationSelected?.organization?.country) {
               dispatch(setCurrentCountry(managedOrganizationSelected.organization.country));
          }

          dispatch(setShow(null));
     };

     const handleCloseButtonClick = () => {
          dispatch(setShow(null));
     };

     return (
          <>
               <CModal id="change-org-popup" className="popup-custom" alignment="center" visible={true} onClose={handleCloseButtonClick} scrollable>
                    <CButton className="close-modal-button" onClick={handleCloseButtonClick}></CButton>
                    <CModalBody>
                         {!orgUser && <PageBack className="back-link-popup" onClick={handleBackClick} title="BACK" />}
                         <h2 className="text-center popup-title">{listOrgs?.length > 0 ? 'Select or' : ''} Create an Organization</h2>
                         <div className="popup-description">
                              <p>
                                   You can build a shopping cart and place an order for only one organization. Organizations can purchase multiple
                                   seats for training products and offer those seats to individuals to complete courses. Think of an Organization as a
                                   business, company, health care group, or non profit.
                              </p>
                              {listOrgs?.length > 0 && <p>Select an option below.</p>}
                         </div>

                         <div className="d-flex flex-column">
                              {listOrgs?.length > 0 && (
                                   <>
                                        {listOrgs.length === 1 ? (
                                             <CButton
                                                  className="mb-3 btn-blue-dark btn-h-50 btn-border"
                                                  onClick={() => handleSelectOrg(listOrgs[0].organizationId)}
                                             >
                                                  {listOrgs[0].organization.name}
                                             </CButton>
                                        ) : (
                                             <CButton className="mb-3 btn-blue-dark btn-h-50 btn-border" onClick={handleShowSelectOrgs}>
                                                  Choose from my existing Organizations
                                             </CButton>
                                        )}
                                   </>
                              )}
                              <CButton className="btn-blue-highlight btn-h-50 btn-border" onClick={handleCreateOrgButtonClick}>
                                   Create a new Organization
                              </CButton>
                         </div>
                    </CModalBody>
               </CModal>
          </>
     );
};

export default SelectOrCreateOrganization;
